import { FGSelectInput, FGTextInput, FieldGroup, FGCheckboxInput } from "nsitools-react";
import * as React from "react";
import * as Yup from "yup";

import { TitleDto, TitlesApi, TitleTranslationDto } from "../../../../../api";
import { ERoutes } from "../../../../../ERoutes";
import { FGMultiTranslate, SmallFormGenerator } from "../../../../../components";
import { useGlobalData } from "../../../../../contexts";
import { useApiService, useCrudApi, useTl } from "../../../../../hooks";
import { useReferential } from "../../../../../hooks/useReferential";
import { ETLCodes } from "../../../../../locales";
import { useParams } from "react-router";

export interface ICountryTitlePanelProps {
  countryId: number;
  currentTitleId: number;
  onDelete: () => void;
  search: () => void;
  belgian: boolean;
}

export const CountryTitlePanel: React.FunctionComponent<ICountryTitlePanelProps> = ({
  countryId,
  currentTitleId,
  onDelete,
  search,
  belgian,
}) => {
  const { t } = useTl();
  const api = useApiService(TitlesApi);
  const { currentLanguage, languages } = useGlobalData();
  const [types, tloading] = useReferential((a) => a.getTitleTypes(currentLanguage.languageId), true, []);
  const { state } = useParams<{ state: string }>();
  const FormSchema = React.useMemo(() => {
    return Yup.object().shape({
      titleTranslations: Yup.array().of(
        Yup.object().shape({
          text: Yup.string().nullable().required(t(ETLCodes.Required)),
        })
      ),
      titleTypeId: Yup.number().nullable().required(t(ETLCodes.Required)),
    });
  }, [t]);

  const { data, loading, deleteItem, deleting, saveItem, saving } = useCrudApi(
    {
      getApiFn: (id = currentTitleId) =>
        id > 0
          ? api.get(id)
          : new TitleDto({
              countryId: countryId,
              titleTypeId: undefined,
              abreviation: undefined,
              titleTranslations: [...languages.map((l) => new TitleTranslationDto({ languageId: l.languageId }))],
            }).toJSON(),
      saveApiFn: (d: TitleDto) => api.save(d),
      onSavedRoute: (d) => `${ERoutes.country}/${countryId}/titles/edit`,
      deleteApiFn: (d) => api.delete(d.titleId),
      onDeletedRoute: (d) => `${ERoutes.country}/${countryId}/titles/edit`,
    },
    [currentTitleId]
  );
  const deleteTitle = React.useCallback(async () => {
    onDelete();
    await deleteItem();
    search();
  }, [deleteItem, onDelete, search]);

  const [articles, aloading] = useReferential((a) => a.getArticles(true), true, []);

  return (
    <SmallFormGenerator
      onSubmit={(d) => saveItem(d).then((c) => search())}
      initialValues={data}
      editMode={state === "edit"}
      onDelete={deleteTitle}
      showDeleteButton={false}
      validationSchema={FormSchema}
      minLabelWidth={120}
      loading={loading}
      saving={saving}
      deleting={deleting}
    >
      <FieldGroup>
        <FGSelectInput name="titleTypeId" label={t(ETLCodes.Type)} items={types} loading={tloading} />
        <FGMultiTranslate
          label={ETLCodes.Name}
          translationsArrayField="titleTranslations"
          translationDto={TitleTranslationDto}
          translationField="text"
        />
        <FGTextInput name="abreviation" label={t(ETLCodes.Abreviation)} />
        {belgian && <FGCheckboxInput name="workRequired" label={t(ETLCodes.WorkRequired)} />}
        <FGSelectInput name="articleId" label={t(ETLCodes.Article)} items={articles} loading={aloading} />
      </FieldGroup>
    </SmallFormGenerator>
  );
};
